export const filterList = [
  'VIPList',
  'platform',
  'zone',
  'status',
  'ipLimit',
  'currency',
  'sendType',
  'userType',
  'isStudent',
  'payMethod',
  'payType',
  'adjustDetail',
  'userScale',
  'accountType',
  'businessType',
  'invoiceStatus',
  'rechargeStatus',
  'downloadDisable',
  'pictureProLevel',
  'organizationType',
  'subuserEffective',
  'frameStatus',
  'taskStatus',
  'productStatus',
  'publishStatus',
  'preHandleStatus',
  'analyseStatus',
  'sky3Status',
  'tileStatus',
  'productTileStatus',
  'rebuildTileStatus',
  'rebuildStatus',
  'channel',
  'channelStatus',
  'userStatus',
  'studentStatus',
  'receiptStatus',
  'educational',
  'invoiceType',
  'invoiceBusinessType',
  'feedbackType',
  'apiStatus',
  'couponType',
  'getWay',
  'engineType',
  'memberType',
  'registerBuildStatus',
  'auditStatus',
  'payStatus',
  'fileType',
  'auditDay',
  // 'authTypeList',
  'registerSourceFlag',
  'mirrorLimit',
  'renderToLeaseStatus',
  'softwareStatus',
  'reportType',
  'inviterCode',
  'isFirstSubmitted',
  'isAuth',
  'rechargeChannels',
  'cdcTag',
]
